me-video-youtube {
  display: block;
  width: 100%;
}

.me-video {
  width: 100%;
  aspect-ratio: 16 / 9;
  position: relative;
  overflow: hidden;

  &__iframe {
    width: 100%;
    height: 100%;
    border: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  &--preview:focus {
    outline: 2px solid #2684ff;
    outline-offset: 2px;
    box-shadow: 0 0 0 4px rgb(38 132 255 / 15%);
    z-index: 2;
  }

  &--preview {
    cursor: pointer;
    position: relative;
    background: var(--color-neutral-neutral-lighter);
  }
}

.me-video__play-btn {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: none;
  width: 128px;
  height: 102px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: rgba(var(--color-neutral-black), 0.15);
  color: var(--color-neutral-white);
  border-radius: 16px;
  transition: background 0.2s;
  cursor: pointer;

  &:hover {
    background: rgba(var(--color-neutral-black), 0.25);
  }

  svg {
    display: block;
  }
}

.me-video__preview-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  z-index: 1;
}
